// extracted by mini-css-extract-plugin
export default {"logos":"_1D8Es9-zHRtJ0nDtDCrCLA==","logo":"tSgMkORVla00OXhX92ZWiw=="};